//import { sendGATapEvent } from './GATracker'

export const inAppURI = uri => 'nankai-app://open-uri?uri=' + uri

export const openURIInApp = (uri, gaCategory = null, gaLabel = null) => {
  if (gaCategory && gaLabel) {
    //sendGATapEvent(gaCategory, gaLabel)
  }
  location.href = inAppURI(uri)
}

export const launchExtAppInApp = (
  string,
  gaCategory = null,
  gaLabel = null
) => {
  if (gaCategory && gaLabel) {
    //sendGATapEvent(gaCategory, gaLabel)
  }
  location.href = `nankai-app://launch-ext-app?${string}`
}

export const callNavigationInApp = query => {
  const url = 'nankai-app://navigation?' + query
  location.href = url
}

export const openOutInApp = (query) => {
  if (!query) {
    return false
  }
  const url = 'nankai-app://out/' + query
  location.href = url
}
